module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ThanksDemoQuestionnaireAlert",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content pb-3"
  }, [_c('div', {
    staticClass: "modal-header py-2"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][101]",
      "isHtml": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding-bottom": "2rem"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][102]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-1"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.answer(1)
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][103]",
      "isHtml": true
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-1"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.answer(0)
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][104]",
      "isHtml": true
    }
  })], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d868151a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ThanksDemoQuestionnaireAlert.vue
// module id = 735
// module chunks = 0